// @ts-nocheck
import { MutableRefObject, RefObject, useEffect, useReducer, useRef } from 'react';
// 方法
import { arrayEqual } from '../../utils/dataUtils';
import { getRulesMessage } from '../../utils/ruleUtils';
// 常量
import { FormInstance } from 'antd/lib/form';
import { groupOptionsProps, SuperFormItemProps } from '../../SuperForm/interface';
import { SearchFormItemProps } from '../../SearchForm';
import { NamePath } from '../../constants/interface';
import { DEFAULT_FIELD_NAMES } from '../../SuperSelect/interface';

export type FormItemActionType = 'format' | 'selectTable' | 'reload' | 'updata';
export interface FormItemPayload {
  name?: NamePath;
  isDetail?: boolean;
  initValues?: any;
  formItems?: SuperFormItemProps[];
  formItem?: SuperFormItemProps;
  form?: FormInstance<any>;
}
export interface IFormItemAction {
  type: FormItemActionType;
  payload: FormItemPayload;
}
function getFormItem(
  formItem: SuperFormItemProps,
  isDetail?: boolean,
  detailForm?: FormInstance<any>,
): SuperFormItemProps {
  const {
    required,
    rules,
    label,
    searchName,
    formItemType,
    buttonProps,
    inputProps,
    textAreaProps,
    inputNumberProps,
    selectProps,
    selectTabProps,
    superSelectProps,
    switchProps,
    associationName,
    selectTableProps,
    superSelectTableProps,
    selectGroupProps,
    datePickerProps,
    rangePickerProps,
    timePickerProps,
    uploadProps,
    startInputNumberProps,
    endInputNumberProps,
    checkboxGroupProps,
    intervalTypeProps,
    numberIntervalProps,
    checkboxProps,
    treeSelectProps,
    cascaderProps,
    autoCompleteProps,
    combinationItem,
    associateSelectProps,
    autoMatchProps,
    radioGroupProps,
    textAreaRowProps,
    uploadAvatarProps,
    dropdownTableProps,
    dropdownSyncTableProps,
    preFormItemProps,
    beforeFormItemProps,
    afterFormItemProps,
    beforeSelectGroupProps,
    afterSelectTableProps,
    superTransferProps,
    routeLinkProps,
    dateRangeProps,
    ...restFormItems
  } = formItem;
  const otherFormItemProps: SearchFormItemProps = { ...restFormItems, formItemType, };
  const baseFormItemProps: SearchFormItemProps = { label, rules, routeLinkProps, };
  if (required && !rules) {
    baseFormItemProps.rules = [
      {
        required: true,
        message: getRulesMessage(formItemType, label),
      },
    ];
    if(formItemType==='Input'){
      // @ts-ignore
      baseFormItemProps.rules[0].whitespace = true;
    }
  }
  switch (formItemType) {
    case 'Button':
      return { ...otherFormItemProps, isDetail, buttonProps: { ...buttonProps } };
    case 'Input':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        inputProps: { ...inputProps },
      };
    case 'AutoComplete':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        autoCompleteProps: { ...autoCompleteProps },
      };
    case 'TextArea':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        textAreaProps: { ...textAreaProps },
      };
    case 'TextAreaRow':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        textAreaRowProps: { ...textAreaRowProps },
      };
    case "IntervalType":
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        intervalTypeProps: { ...intervalTypeProps },
      };
    case "DateRange":
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        dateRangeProps: { ...dateRangeProps },
      };
    case "NumberInterval":
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        numberIntervalProps: { ...numberIntervalProps },
      };
    case "SuperTransfer":
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        superTransferProps: {
          ...superTransferProps,
          onChange: (value: any) => {
            associationName && detailForm?.current?.setFieldValue(associationName, undefined);
            superTransferProps?.onChange?.(value);
          },
        },
      };
    case 'DropdownTable':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        dropdownTableProps: {...dropdownTableProps},
      };
    case 'DropdownSyncTable':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        dropdownSyncTableProps: { ...dropdownSyncTableProps},
      };

    case 'InputInterval':
      const intervalPreRules: SearchFormItemProps = {};
      if (required && !preFormItemProps?.rules) {
        intervalPreRules.rules = [
          {
            required: true,
            message: getRulesMessage(formItemType, `${label}开始区间`),
          },
        ];
      }
      const intervalAfterRules: SearchFormItemProps = {};
      if (required && !afterFormItemProps?.rules) {
        intervalAfterRules.rules = [
          {
            required: true,
            message: getRulesMessage(formItemType, `${label}结束区间`),
          },
        ];
      }
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        preFormItemProps: { ...preFormItemProps, ...intervalPreRules },
        afterFormItemProps: { ...afterFormItemProps, ...intervalAfterRules },
        startInputNumberProps: { ...startInputNumberProps },
        endInputNumberProps: { ...endInputNumberProps },
      };
    case 'SelectCustom':
      return {
        ...otherFormItemProps,
        isDetail,
      };
    case 'InputNumber':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        inputNumberProps: { ...inputNumberProps },
      };
    case 'Select':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        selectProps: {
          ...selectProps,
          onChange: (value: any, options: any) => {
            associationName && detailForm?.current?.setFieldValue(associationName, undefined);
            selectProps?.onChange?.(value, options);
          },
        },
      };
    case 'SelectTab':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        selectTabProps: {
          ...selectTabProps,
          onChange: (value: any, options: any) => {
            associationName && detailForm?.current?.setFieldValue(associationName, undefined);
            selectTabProps?.onChange?.(value, options);
          },
        },
      };
    case 'SuperSelect':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        superSelectProps: {
          ...superSelectProps,
          onChange: (value: any, options: any) => {
            associationName && detailForm?.current?.setFieldValue(associationName, undefined);
            superSelectProps?.onChange?.(value, options);
          },
        },
      };
    case 'TreeSelect':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        treeSelectProps: { ...treeSelectProps },
      };
    case 'Cascader':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        cascaderProps: {
          ...cascaderProps,
          onChange: (value: any, item: any) => {
            associationName && detailForm?.current?.setFieldValue(associationName, undefined);
            cascaderProps?.onChange?.(value, item, detailForm?.current);
          },
        },
      };
    case 'AssociateSelect':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        associateSelectProps: { ...associateSelectProps },
      };
    case 'AutoMatch':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        autoMatchProps: { ...autoMatchProps },
      };
    case 'Switch':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        switchProps: { ...switchProps },
      };
    case 'RadioGroup':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        radioGroupProps: { ...radioGroupProps },
      };
    case 'Checkbox':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        checkboxProps: { ...checkboxProps },
      };
    case 'CheckboxGroup':
      return {
        ...otherFormItemProps,
        ...baseFormItemProps,
        isDetail,
        checkboxGroupProps: { ...checkboxGroupProps },
      };
    case 'Combination':
      const newCombinationItem = combinationItem?.map(item => {
        const { formItemProps } = item;
        if (required && !formItemProps?.rules) {
          return {
            ...item,
            formItemProps: {
              ...formItemProps,
              rules: [
                {
                  required: true,
                  message: getRulesMessage(item.formItemType, item.label),
                },
              ],
            },
          };
        }
        return item;
      });
      return { ...otherFormItemProps, ...baseFormItemProps, isDetail, combinationItem: newCombinationItem };
    case 'SelectTable':
      return selectTableProps
        ? {
            ...otherFormItemProps,
            ...baseFormItemProps,
            isDetail,
            selectTableProps: {
              ...selectTableProps,
              onChange: (value: any, options: any) => {
                associationName && detailForm?.current?.setFieldValue(associationName, undefined);
                selectTableProps?.onChange?.(value, options, detailForm?.current);
              },
            },
          }
        : { ...otherFormItemProps, ...baseFormItemProps, isDetail };
    case 'SuperSelectTable':
      const newSuperSelectTableProps = superSelectTableProps
        ? {
            ...otherFormItemProps,
            ...baseFormItemProps,
            isDetail,
            superSelectTableProps: {
              ...superSelectTableProps,
              onChange: (value: any, options: any) => {
                associationName && detailForm?.current?.setFieldValue(associationName, undefined);
                superSelectTableProps?.onChange?.(value, options);
              },
            },
          }
        : { ...otherFormItemProps, ...baseFormItemProps, isDetail };
      return newSuperSelectTableProps;
    case 'SelectGroup':
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        selectGroupProps: {
          ...selectGroupProps,
          onChange: (value: any, options: any) => {
            associationName && detailForm?.current?.setFieldValue(associationName, undefined);
            selectGroupProps?.onChange?.(value, options);
          },
        },
      };
    case 'SelectGroupTable':
      const selectWarehouseBeforeRules: SearchFormItemProps = {};
      if (required && !beforeFormItemProps?.rules) {
        selectWarehouseBeforeRules.rules = [
          {
            required: true,
            message: '请选择仓库',
          },
        ];
      }
      const selectWarehouseAfterRules: SearchFormItemProps = {};
      if (required && !beforeFormItemProps?.rules) {
        selectWarehouseAfterRules.rules = [
          {
            required: true,
            message: '请选择卖家',
          },
        ];
      }
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        searchName,
        beforeFormItemProps: {...selectWarehouseBeforeRules, ...beforeFormItemProps},
        afterFormItemProps: {...selectWarehouseAfterRules, ...afterFormItemProps},
        beforeSelectGroupProps,
        afterSelectTableProps,
      };
    case 'SelectInput':
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        selectProps: { ...selectProps },
        inputProps: { ...inputProps },
      };
    case 'InputSelect':
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        selectProps: { ...selectProps },
        inputProps: { ...inputProps },
      };
    case 'DatePicker':
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        datePickerProps: { ...datePickerProps },
      };
    case 'RangePicker':
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        rangePickerProps: { ...rangePickerProps },
      };
    case 'TimePicker':
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        timePickerProps: { ...timePickerProps },
      };
    case 'TimeSlot':
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        datePickerProps: { ...datePickerProps },
      };
    case 'UploadAvatar':
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        uploadAvatarProps: { ...uploadAvatarProps },
      };
    case 'Upload':
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        uploadProps: { ...uploadProps },
      };
    case 'UploadImage':
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        uploadProps: { ...uploadProps },
      };
    case 'UploadImages':
      return {
        ...formItem,
        ...baseFormItemProps,
        isDetail,
        uploadProps: { ...uploadProps },
      };
    case 'Group':
      if (Array.isArray(formItem.groupOptions)) {
        return {
          ...formItem,
          groupOptions: formItem.groupOptions.map((item: any) => {
            return {
              ...item,
              children: item?.children?.map?.((item: SuperFormItemProps) =>
                getFormItem(item, isDetail, detailForm),
              ),
            };
          }),
        };
      }
      if (Array.isArray(formItem.children)) {
        return {
          ...formItem,
          children: formItem.children.map((item: SuperFormItemProps) =>
            getFormItem(item, isDetail, detailForm),
          ),
        };
      }
      return formItem;
    case 'Fixed':
      if (Array.isArray(formItem.children)) {
        return {
          ...formItem,
          children: formItem.children.map((item: SuperFormItemProps) =>
            getFormItem(item, isDetail, detailForm),
          ),
        };
      }
      return formItem;
    case 'Tabs':
      if (Array.isArray(formItem.tabPanes)) {
        return {
          ...formItem,
          isDetail,
          tabPanes: formItem.tabPanes.map(item => {
            if (Array.isArray(item.children)) {
              return {
                ...item,
                children: item.children.map((v: SuperFormItemProps) =>
                  getFormItem(v, isDetail, detailForm),
                ),
              };
            }
            return item;
          }),
        };
      }
      return { ...formItem, isDetail };
    case 'CustomItem':
      return {
        ...formItem,
        ...baseFormItemProps,
        renderDisabled: isDetail,
      };
    default:
      return { ...formItem, isDetail };
  }
}
function setOptions(
  formItems: SuperFormItemProps[],
  initValues: any,
): SuperFormItemProps[] {
  return formItems.map(formItem => {
    if (formItem.formItemType === 'Group') {
      const groupChildren = Array.isArray(formItem.groupOptions) ? formItem.groupOptions[0].children : formItem.children;
      return {
        ...formItem,
        groupOptions: formItem.groupOptions ? [
          {
            ...formItem.groupOptions[0],
            children: setOptions(formItem.groupOptions[0].children as SuperFormItemProps[], initValues),
          },
          {
            ...formItem.groupOptions[1],
            children: setOptions(formItem.groupOptions[1].children as SuperFormItemProps[], initValues),
          },
        ] : undefined,
        children: setOptions(
          groupChildren as SuperFormItemProps[],
          initValues,
        ),
      };
    }
    if (
      formItem.formItemType === 'Fixed'
    ) {
      return {
        ...formItem,
        children: setOptions(
          formItem.children as SuperFormItemProps[],
          initValues,
        ),
      };
    }
    if (formItem.formItemType === 'Tabs') {
      return {
        ...formItem,
        tabPanes: formItem.tabPanes?.map(tabPane => {
          const children = tabPane.children;
          if (Array.isArray(children)) {
            return {
              ...tabPane,
              children: setOptions(
                tabPane.children as SuperFormItemProps[],
                initValues,
              ),
            };
          }
          return tabPane;
        }),
      };
    }
    if (formItem.formItemType === 'SelectTable' && formItem.selectTableProps) {
      const initOptions: any[] = formItem.selectTableProps.initOptions || [];
      if (formItem.valuekey && formItem.namekey && initValues) {
        const { nameKey, valueKey } = formItem.selectTableProps;
        if (
          Array.isArray(initValues[formItem.valuekey]) &&
          Array.isArray(initValues[formItem.namekey])
        ) {
          initValues[formItem.valuekey].forEach((item: any, index: number) => {
            const findItem = initOptions.find(v => v[valueKey] === item);
            if (!findItem) {
              initOptions.push({
                [valueKey]: item,
                [nameKey]: initValues[formItem.namekey as string][index],
              });
            }
          });
        } else {
          if (initValues[formItem.valuekey] && initValues[formItem.namekey]) {
            const findItem = initOptions.find(v => v[valueKey] === initValues[formItem.valuekey]);
            if (!findItem) {
              initOptions.push({
                [valueKey]: initValues[formItem.valuekey],
                [nameKey]: initValues[formItem.namekey],
              });
            }
          }
        }
      }
      return {
        ...formItem,
        selectTableProps: {
          ...formItem.selectTableProps,
          initOptions,
        },
      };
    }
    if (formItem.formItemType === 'SuperSelectTable' && formItem.superSelectTableProps) {
      // 不继承上一次的默认值 测试一段时间
      // const initOptions: any[] = formItem.superSelectTableProps.initOptions || [];
      const initOptions: any[] = [];
      if (formItem.valueKey && formItem.labelKey && initValues) {
        const labelKey = formItem.superSelectTableProps.labelKey || formItem.superSelectTableProps.fieldNames?.label || DEFAULT_FIELD_NAMES.label;
        const valueKey = formItem.superSelectTableProps.valueKey || formItem.superSelectTableProps.fieldNames?.value || DEFAULT_FIELD_NAMES.value;
        if (
          Array.isArray(initValues[formItem.valueKey]) &&
          Array.isArray(initValues[formItem.labelKey])
        ) {
          initValues[formItem.valueKey].forEach((item: any, index: number) => {
            const findItem = initOptions.find(v => v[valueKey] === item);
            if (!findItem) {
              initOptions.push({
                [valueKey]: item,
                [labelKey]: initValues[formItem.labelKey as string][index],
              });
            }
          });
        } else {
          if (initValues[formItem.valueKey] && initValues[formItem.labelKey]) {
            const findItem = initOptions.find(v => v[valueKey] === initValues[formItem.valueKey]);
            if (!findItem) {
              initOptions.push({
                [valueKey]: initValues[formItem.valueKey],
                [labelKey]: initValues[formItem.labelKey],
              });
            }
          }
        }
      }
      return {
        ...formItem,
        superSelectTableProps: {
          ...formItem.superSelectTableProps,
          initOptions: initOptions.slice(),
        },
      };
    }
    if (formItem.formItemType === 'SelectTab' && formItem.selectTabProps) {
      // 不继承上一次的默认值 测试一段时间
      // const initOptions: any[] = formItem.superSelectTableProps.initOptions || [];
      const initOptions: any[] = [];
      if (formItem.valueKey && formItem.labelKey && initValues) {
        const labelKey = formItem.selectTabProps.fieldNames?.label || DEFAULT_FIELD_NAMES.label;
        const valueKey = formItem.selectTabProps.fieldNames?.value || DEFAULT_FIELD_NAMES.value;
        if (
          Array.isArray(initValues[formItem.valueKey]) &&
          Array.isArray(initValues[formItem.labelKey])
        ) {
          initValues[formItem.valueKey].forEach((item: any, index: number) => {
            const findItem = initOptions.find(v => v[valueKey] === item);
            if (!findItem) {
              initOptions.push({
                [valueKey]: item,
                [labelKey]: initValues[formItem.labelKey as string][index],
              });
            }
          });
        } else {
          if (initValues[formItem.valueKey] && initValues[formItem.labelKey]) {
            const findItem = initOptions.find(v => v[valueKey] === initValues[formItem.valueKey]);
            if (!findItem) {
              initOptions.push({
                [valueKey]: initValues[formItem.valueKey],
                [labelKey]: initValues[formItem.labelKey],
              });
            }
          }
        }
      }
      return {
        ...formItem,
        selectTabProps: {
          ...formItem.selectTabProps,
          initOptions: initOptions.slice(),
        },
      };
    }
    if (formItem.formItemType === 'SelectGroupTable' && formItem.afterSelectTableProps) {
      const initOptions: any[] = formItem.afterSelectTableProps.initOptions || [];
      if (formItem.valuekey && formItem.namekey && initValues) {
        const { nameKey, valueKey } = formItem.afterSelectTableProps;
        if (
          Array.isArray(initValues[formItem.valuekey]) &&
          Array.isArray(initValues[formItem.namekey])
        ) {
          initValues[formItem.valuekey].forEach((item: any, index: number) => {
            const findItem = initOptions.find(v => v[valueKey] === item);
            if (!findItem) {
              initOptions.push({
                [valueKey]: item,
                [nameKey]: initValues[formItem.namekey as string][index],
              });
            }
          });
        } else {
          if (initValues[formItem.valuekey] && initValues[formItem.namekey]) {
            const findItem = initOptions.find(v => v[valueKey] === initValues[formItem.valuekey]);
            if (!findItem) {
              initOptions.push({
                [valueKey]: initValues[formItem.valuekey],
                [nameKey]: initValues[formItem.namekey],
              });
            }
          }
        }
      }
      
      if (formItem.disabledRenderKey && initValues) {
        if (typeof formItem.disabledRenderKey === 'function') {
          formItem.disabledRender = formItem.disabledRenderKey(initValues);
        }
        if (typeof formItem.disabledRenderKey === 'string') {
          formItem.disabledRender = initValues[formItem.disabledRenderKey];
        }
      }
      const selectWarehouseItem = {
        ...formItem,
        afterSelectTableProps: {
          ...formItem.afterSelectTableProps,
          initOptions,
        },
      };
      return selectWarehouseItem;
    }
    if (formItem.disabledRenderKey && initValues) {
      if (typeof formItem.disabledRenderKey === 'function') {
        formItem.disabledRender = formItem.disabledRenderKey(initValues);
      }
      if (typeof formItem.disabledRenderKey === 'string') {
        formItem.disabledRender = initValues[formItem.disabledRenderKey];
      }
    }
    return formItem;
  });
}
function formItemMerge(
  formItems: SuperFormItemProps[],
  formItemsCopy?: SuperFormItemProps[],
  initValues?: any,
): SuperFormItemProps[] {
  if (!formItemsCopy) {
    return formItems;
  }
  return formItems.map((formItem, index) => {
    if (formItem.formItemType === 'Group') {
      let newFormItemsCopy: SuperFormItemProps[] = [];
      let groupOptions: [groupOptionsProps, groupOptionsProps] | undefined;
      if (formItem.name) {
        const findItem = formItemsCopy.find(v => v.name === formItem.name);
        newFormItemsCopy = findItem?.children as SuperFormItemProps[];
        groupOptions = findItem?.groupOptions || formItems?.[index]?.groupOptions;
      } else {
        const findItem = formItemsCopy?.[index];
        newFormItemsCopy = findItem?.children as SuperFormItemProps[];
        groupOptions = findItem?.groupOptions || formItems?.[index]?.groupOptions;
      }
      const groupChildren = Array.isArray(formItem.groupOptions) ? formItem.groupOptions[0].children : formItem.children;
      return {
        ...formItem,
        groupOptions: groupOptions ? [
          {
            ...groupOptions[0],
            children: formItemMerge(groupOptions[0].children as SuperFormItemProps[], groupOptions[0].children, initValues),
          },
          {
            ...groupOptions[1],
            children: formItemMerge(groupOptions[1].children as SuperFormItemProps[], groupOptions[1].children, initValues),
          },
        ] : undefined,
        children: formItemMerge(
          groupChildren as SuperFormItemProps[],
          newFormItemsCopy,
          initValues,
        ),
      };
    }
    if (formItem.formItemType === 'Fixed') {
      let newFormItemsCopy: SuperFormItemProps[] = [];
      if (formItem.name) {
        newFormItemsCopy = formItemsCopy.find(v => v.name === formItem.name)
          ?.children as SuperFormItemProps[];
      } else {
        newFormItemsCopy = formItemsCopy?.[index]
          ?.children as SuperFormItemProps[];
      }
      return {
        ...formItem,
        children: formItemMerge(
          formItem.children as SuperFormItemProps[],
          newFormItemsCopy,
          initValues,
        ),
      };
    }
    if (formItem.formItemType === 'Tabs') {
      return {
        ...formItem,
        tabPanes: formItem.tabPanes?.map(tabPane => {
          const children = tabPane.children;
          if (Array.isArray(children)) {
            const copyTabPane = formItemsCopy?.[index]?.tabPanes?.find(
              v => v.key === tabPane.key,
            );
            // setOptions
            if (copyTabPane) {
              return {
                ...tabPane,
                children: formItemMerge(
                  children as SuperFormItemProps[],
                  copyTabPane
                    ? (copyTabPane.children as SuperFormItemProps[])
                    : [],
                  initValues,
                ),
              };
            }
            return {
              ...tabPane,
              children: setOptions(children, initValues),
            };
          }
          return tabPane;
        }),
      };
    }
    if (formItem.formItemType === 'SelectTable') {
      const findFormItem = formItemsCopy?.find?.(v =>
        arrayEqual(v.name, formItem.name),
      );
      const selectTableProps = formItem.selectTableProps;
      if (findFormItem && selectTableProps) {
        const selectTablePropsCopy = findFormItem.selectTableProps;
        if (!selectTablePropsCopy) return formItem;
        const { initOptions } = selectTablePropsCopy;
        return {
          ...formItem,
          selectTableProps: {
            ...selectTableProps,
            initOptions,
          },
        };
      }
      return formItem;
    }
    if (formItem.formItemType === 'SuperSelectTable') {
      const findFormItem = formItemsCopy?.find?.(v =>
        arrayEqual(v.name, formItem.name),
      );
      const superSelectTableProps = formItem.superSelectTableProps;
      if (findFormItem && superSelectTableProps) {
        const selectTablePropsCopy = findFormItem.superSelectTableProps;
        if (!selectTablePropsCopy) return formItem;
        const currentInitOptions = superSelectTableProps.initOptions;
        const prevInitOptions = selectTablePropsCopy.initOptions;
        const valueKey = superSelectTableProps.valueKey;
        // 待合并的initOptions
        const initOptions: any[] = Array.isArray(prevInitOptions) ? prevInitOptions : [];
        // initOptions 是否需要更新引用地址
        let flag: boolean = false;
        if (Array.isArray(currentInitOptions) && currentInitOptions.length && valueKey) {
          currentInitOptions.forEach(item => {
            const findItem = initOptions.find(v => v[valueKey] === item[valueKey]);
            if (!findItem) {
              initOptions.push(item);
              flag = true;
            }
          });
        }
        return {
          ...formItem,
          superSelectTableProps: {
            ...superSelectTableProps,
            initOptions: flag ? initOptions.slice() : initOptions,
          },
        };
      }
      return formItem;
    }
    if (formItem.formItemType === 'SelectTab') {
      const findFormItem = formItemsCopy?.find?.(v =>
        arrayEqual(v.name, formItem.name),
      );
      const selectTabProps = formItem.selectTabProps;
      if (findFormItem && selectTabProps) {
        const selectTabPropsCopy = findFormItem.selectTabProps;
        if (!selectTabPropsCopy) return formItem;
        const currentInitOptions = selectTabProps.initOptions;
        const prevInitOptions = selectTabPropsCopy.initOptions;
        const valueKey = selectTabProps.fieldNames?.value || DEFAULT_FIELD_NAMES.value;
        // 待合并的initOptions
        const initOptions: any[] = Array.isArray(prevInitOptions) ? prevInitOptions : [];
        // initOptions 是否需要更新引用地址
        let flag: boolean = false;
        if (Array.isArray(currentInitOptions) && currentInitOptions.length && valueKey) {
          currentInitOptions.forEach(item => {
            const findItem = initOptions.find(v => v[valueKey] === item[valueKey]);
            if (!findItem) {
              initOptions.push(item);
              flag = true;
            }
          });
        }
        return {
          ...formItem,
          selectTabProps: {
            ...selectTabProps,
            initOptions: flag ? initOptions.slice() : initOptions,
          },
        };
      }
      return formItem;
    }
    if (formItem.formItemType === 'SelectGroupTable') {
      const findFormItem = formItemsCopy?.find?.(v =>
        arrayEqual(v.name, formItem.name),
      );
      const selectTableProps = formItem.afterSelectTableProps;
      if (findFormItem && selectTableProps) {
        const selectTablePropsCopy = findFormItem.afterSelectTableProps;
        if (!selectTablePropsCopy) return formItem;
        // const { disabled, otherParams, ...resProps } = selectTablePropsCopy;
        const { initOptions } = selectTablePropsCopy;
        if (findFormItem && findFormItem.disabledRender) {
          formItem.disabledRender = findFormItem.disabledRender;
        }
        return {
          ...formItem,
          afterSelectTableProps: {
            ...selectTableProps,
            initOptions,
          },
        };
      }
      return formItem;
    }
    if (
      formItemsCopy &&
      formItemsCopy[index] &&
      arrayEqual(formItem.name, formItemsCopy[index].name) &&
      formItemsCopy[index].disabledRender
    ) {
      formItem.disabledRender = formItemsCopy[index].disabledRender;
    }
    return formItem;
  });
}
function FormItemAction(state: SuperFormItemProps[], action: IFormItemAction) {
  const { isDetail, formItems, formItem, name, initValues, detailForm } = action.payload;
  switch (action.type) {
    case 'format':
      const newFormItems = formItems ? formItemMerge(formItems, state, initValues) : state;
      const aaa = newFormItems.map(formItem => getFormItem(formItem, isDetail, detailForm));
      return aaa;
    case 'selectTable':
      const bbb = setOptions(state, initValues);
      return bbb;
    case 'reload':
      return formItems ? [...formItems] : state;
    case 'updata':
      return name && formItem ? updateFormItem(state, name, formItem) : state;
    default:
      return state;
  }
}
function updateFormItem(
  formItems: SuperFormItemProps[],
  name: NamePath,
  formItem: SuperFormItemProps,
): SuperFormItemProps[] {
  return formItems.map(item => {
    if (item.formItemType === 'Fixed' || item.formItemType === 'Group') {
      const children = item.children;
      if (Array.isArray(children)) {
        return {
          ...item,
          children: updateFormItem(
            children as SuperFormItemProps[],
            name,
            formItem,
          ),
        };
      }
      return item;
    }
    if (item.formItemType === 'Tabs') {
      return {
        ...item,
        tabPanes: item.tabPanes?.map(tabPane => {
          const tabPaneChildren = tabPane.children;
          if (Array.isArray(tabPaneChildren) && tabPaneChildren.length) {
            return {
              ...tabPane,
              children: updateFormItem(
                tabPaneChildren as SuperFormItemProps[],
                name,
                formItem,
              ),
            };
          }
          return tabPane;
        }),
      };
    }
    if (arrayEqual(item.name, name)) {
      switch (item.formItemType) {
        case 'SelectTable':
          const { selectTableProps } = item;
          if (selectTableProps) {
            return {
              ...item,
              selectTableProps: {
                ...selectTableProps,
                ...formItem,
              },
            };
          }
          return item;
        case 'SuperSelectTable':
          const { superSelectTableProps } = item;
          if (superSelectTableProps) {
            return {
              ...item,
              superSelectTableProps: {
                ...superSelectTableProps,
                ...formItem,
              },
            };
          }
          return item;
        case 'SelectGroupTable':
          const { afterSelectTableProps } = item;
          if (afterSelectTableProps) {
            return {
              ...item,
              afterSelectTableProps: {
                ...afterSelectTableProps,
                ...formItem,
              },
            };
          }
          return item;
        default:
          return item;
      }
    }
    return item;
  });
}
function useFormItems(
  formItems: SuperFormItemProps[],
  isDetail?: boolean,
  isEmpty?: boolean,
  detailForm?: MutableRefObject<FormInstance<any> | undefined>,
  historyInitValue?: RefObject<any>,
) {
  const [currentFormItems, formItemDispatch] = useReducer(
    FormItemAction,
    formItems,
  );
  useEffect(() => {
    if (isEmpty) {
      formItemDispatch({
        type: 'reload',
        payload: { formItems: formItems },
      });
    } else {
      formItemDispatch({
        type: 'format',
        payload: { isDetail: !!isDetail, formItems, detailForm, initValues: historyInitValue?.current },
      });
    }
  }, [formItems, isDetail, isEmpty]);
  return {
    currentFormItems,
    formItemDispatch,
  };
}

export default useFormItems;
